import { z } from 'zod'

import { EnumBuilder, type ZodSimplify } from '@mntn-dev/utility-types'
import { BidIdSchema } from '../unique-id.models.ts'
import { SurveyFeedbackSchema } from './common.ts'
import { SurveyTypeSchema } from './survey-types.ts'

export const [
  BidAcceptedReasons,
  BidAcceptedReasonSchema,
  BidAcceptedReasonEnum,
] = EnumBuilder(
  'relevant-examples-past-work',
  'expert-in-required-skillset',
  'within-budget',
  'great-past-experience-with-maker',
  'excellent-pitch',
  'in-ideal-location-fluent-in-required-language',
  'other'
)

export type BidAcceptedReason = ZodSimplify<typeof BidAcceptedReasonSchema>

export const BidAcceptedResponsesSchema = z.discriminatedUnion('reason', [
  z.object({
    reason: BidAcceptedReasonSchema.extract(['other']),
    feedback: SurveyFeedbackSchema,
  }),
  z.object({
    reason: BidAcceptedReasonSchema.exclude(['other']),
    feedback: SurveyFeedbackSchema.optional(),
  }),
])

export type BidAcceptedResponses = ZodSimplify<
  typeof BidAcceptedResponsesSchema
>

export const BidAcceptedSurveyDetailsSchema = z.object({
  surveyType: SurveyTypeSchema.extract(['bid-accepted-by-brand']),
  bidId: BidIdSchema,
  responses: BidAcceptedResponsesSchema,
})
